import { buildBackendUrl } from "@/shared/api/backend";

type DebugLogData = unknown;

const debugLogsEnabled = isEnabled(import.meta.env.VITE_DEBUG_LOGS as string | undefined);

export function debugLog(scope: string, message: string, data?: DebugLogData) {
	const entry = { scope, message, data };
	console.debug(`[${scope}] ${message}`, data);

	if (!debugLogsEnabled || typeof window === "undefined") {
		return;
	}

	void sendDebugLog(entry);
}

async function sendDebugLog(entry: { scope: string; message: string; data?: DebugLogData }) {
	try {
		await fetch(buildBackendUrl("/debug/log"), {
			method: "POST",
			credentials: "include",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
                ...entry,
                path: window.location.pathname,
            }),
		});
	} catch {
		// Debug logging must never interrupt the UI.
	}
}

function isEnabled(value: string | undefined) {
	const normalized = (value ?? "").trim().toLowerCase();
	return normalized === "1" || normalized === "true" || normalized === "yes" || normalized === "on";
}
